// @flow
import styled from 'styled-components';
/*::
import type { Node } from 'react';

export type PanelThemeType = {|
  Main: * => Node,
|};
*/

var thm
/*: PanelThemeType */
= {
  // default theme
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "vjp4cm-0"
  })(["padding:0.8rem 3rem;display:none;width:100%;&.active{display:block;}"])
};
export default thm;